// extracted by mini-css-extract-plugin
export var border = "IntroHeroWithImage-module--border--f1d95";
export var bordersection = "IntroHeroWithImage-module--bordersection--6306c";
export var herowithimagecontainer = "IntroHeroWithImage-module--herowithimagecontainer--ec676";
export var imagecontainer = "IntroHeroWithImage-module--imagecontainer--633ce";
export var imagewrapper = "IntroHeroWithImage-module--imagewrapper--b931c";
export var subtitle = "IntroHeroWithImage-module--subtitle--fa707";
export var tealbackground = "IntroHeroWithImage-module--tealbackground--b2417";
export var textcontainer = "IntroHeroWithImage-module--textcontainer--5a1af";
export var title = "IntroHeroWithImage-module--title--e67b7";
export var topsectionouter = "IntroHeroWithImage-module--topsectionouter--b6e80";
export var yellowbackground = "IntroHeroWithImage-module--yellowbackground--04a8f";